(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lamier-deferred-video"] && !Shopify.designMode) return;
  try {
    function loadLamierVideo(video){
  if(video.dataset.lrVideoLoaded)return;
  video.querySelectorAll('[data-src]').forEach(source=>{source.src=source.dataset.src;source.removeAttribute('data-src');});
  if(video.dataset.src){video.src=video.dataset.src;video.removeAttribute('data-src');}
  video.dataset.lrVideoLoaded='1';
  video.load();
}
function playLamierVideo(video){
  loadLamierVideo(video);
  const playing=video.play();
  if(playing)playing.catch(()=>{});
}
const lamierVideoObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
  entries.forEach(entry=>{
    if(entry.isIntersecting)playLamierVideo(entry.target);
    else entry.target.pause();
  });
},{rootMargin:'200px 0px',threshold:0.01}):null;
function initLamierVideos(){
  document.querySelectorAll('video[data-lr-video]').forEach(video=>{
    if(video.dataset.lrVideoBound)return;
    video.dataset.lrVideoBound='1';
    if(lamierVideoObserver)lamierVideoObserver.observe(video);
    else playLamierVideo(video);
  });
}
initLamierVideos();
document.addEventListener('shopify:section:load',initLamierVideos);
document.addEventListener('shopify:section:unload',event=>{
  event.target.querySelectorAll('video[data-lr-video]').forEach(video=>{lamierVideoObserver?.unobserve(video);video.pause();});
});
document.addEventListener('click',event=>{
  const toggle=event.target.closest('[data-video-toggle]');
  if(!toggle)return;
  const video=toggle.parentElement.querySelector('video[data-lr-video]');
  if(!video)return;
  video.muted=!video.muted;
  toggle.textContent=video.muted?'◖))':'×';
  toggle.setAttribute('aria-pressed',String(!video.muted));
  playLamierVideo(video);
});
  } catch(e) { console.error(e); }
})();

})();
